import React, { useState } from 'react';

import * as CategoryModule from 'modules/category';

import Banner from './components/Banner';
import CategoryList from './components/CategoryList';
import Stats from './components/Stats';
import NewsList from './components/NewsList';
import MobileApps from './components/MobileApps';

import classes from './LandingPage.module.scss';

const Landing: React.FC = () => {
  const [search, setSearch] = useState('');

  return (
    <CategoryModule.Context.Single.Provider>
      <div className={classes.wrapper}>
        <div className={classes.wrapperInner}>
          <Banner {...{ search, setSearch }} />
          <hr className={classes.mobileDivider} />
          {!search ? (
            <CategoryList />
          ) : (
            <div className={classes.section}>
              <CategoryModule.Containers.SearchResultList {...{ search }} />
            </div>
          )}
          <hr className={classes.mobileDivider} />
          <Stats />
          <hr className={classes.mobileDivider} />
          <NewsList />
          <hr className={classes.mobileDivider} />
          <MobileApps />
        </div>
      </div>
    </CategoryModule.Context.Single.Provider>

  );
};

export default Landing;